import {ref, watch, nextTick, onMounted} from "vue";
import {useEventListener, useResizeObserver} from "@vueuse/core";

// the fade at the foot of a scrolling list only makes sense while rows are
// left below it, as in SipServerInfo; `count` re-checks once a page is added
export default function useScrollFade(target, count) {
    const isBottom = ref(true)

    const sync = () => {
        const el = target.value
        if (!el) return

        isBottom.value = el.scrollTop + el.clientHeight >= el.scrollHeight - 1
    }

    useEventListener(target, 'scroll', sync, {passive: true})
    useResizeObserver(target, sync)
    watch(count, () => nextTick(sync))
    onMounted(sync)

    return {isBottom}
}
